var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.25H9C3.57 23.25 1.25 20.93 1.25 15.5V9.5C1.25 4.07 3.57 1.75 9 1.75H15C20.43 1.75 22.75 4.07 22.75 9.5V15.5C22.75 20.93 20.43 23.25 15 23.25ZM9 3.25C4.39 3.25 2.75 4.89 2.75 9.5V15.5C2.75 20.11 4.39 21.75 9 21.75H15C19.61 21.75 21.25 20.11 21.25 15.5V9.5C21.25 4.89 19.61 3.25 15 3.25H9Z",
    fill: "#669D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C7.48 11.25 6.25 10.02 6.25 8.5C6.25 6.98 7.48 5.75 9 5.75C10.52 5.75 11.75 6.98 11.75 8.5C11.75 10.02 10.52 11.25 9 11.25ZM9 7.25C8.31 7.25 7.75 7.81 7.75 8.5C7.75 9.19 8.31 9.75 9 9.75C9.69 9.75 10.25 9.19 10.25 8.5C10.25 7.81 9.69 7.25 9 7.25Z",
    fill: "#669D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66977 20.2C2.42977 20.2 2.18977 20.08 2.04977 19.87C1.81977 19.53 1.90977 19.06 2.25977 18.83L7.18977 15.52C8.26977 14.79 9.75977 14.88 10.7398 15.71L11.0698 16C11.5698 16.43 12.4198 16.43 12.9098 16L17.0698 12.43C18.1298 11.52 19.7998 11.52 20.8698 12.43L22.4998 13.83C22.8098 14.1 22.8498 14.57 22.5798 14.89C22.3098 15.2 21.8398 15.24 21.5198 14.97L19.8898 13.57C19.3898 13.14 18.5398 13.14 18.0398 13.57L13.8798 17.14C12.8198 18.05 11.1498 18.05 10.0798 17.14L9.74977 16.85C9.28977 16.46 8.52977 16.42 8.01977 16.77L3.08977 20.08C2.95977 20.16 2.80977 20.2 2.66977 20.2Z",
    fill: "#669D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.a542f95cd26c35cbc741bf3766f4d587.svg";
export { ForwardRef as ReactComponent };